// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ModalRenderer_backdrop__2odR8","modalWrapper":"ModalRenderer_modalWrapper__2Shwi","maximized":"ModalRenderer_maximized__3gbIQ"};